import { MantineThemeOverride } from '@mantine/core';
import { IconName } from '../config/icon-map';

export type IconVariant = 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'muted';

export const iconSizes: Record<'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl', number> = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
  '2xl': 40,
};

export const defaultIconSet: IconName[] = [
  'apps',
  'alert',
  'bell',
  'calendar',
  'check',
  'database',
  'layout',
  'palette',
  'search',
  'settings',
  'shopping-cart',
  'stack',
  'star',
  'sun',
  'moon',
  'user',
  'users',
  'user-shield',
];

export function resolveIconColor(
  theme: MantineThemeOverride | Record<string, any>,
  color?: string,
  variant?: IconVariant
): string | undefined {
  if (color) return color;

  const palette = theme.colors?.[theme.primaryColor || 'blue'] ?? [];
  const semantic = theme.other as Record<string, any>;

  switch (variant) {
    case 'primary':
      return palette[6];
    case 'secondary':
      return semantic?.gradients?.secondary?.from || palette[5];
    case 'success':
      return '#22c55e';
    case 'warning':
      return '#f59e0b';
    case 'danger':
      return '#ef4444';
    case 'info':
      return '#0ea5e9';
    case 'muted':
      return theme.colors?.gray?.[6];
    default:
      return palette[7] || '#4b5563';
  }
}

export function withIconTokens(theme: MantineThemeOverride): MantineThemeOverride {
  return {
    ...theme,
    other: {
      ...(theme.other || {}),
      icons: {
        sizes: iconSizes,
        defaultSet: defaultIconSet,
      },
    },
  };
}
